<iris-dms-trash-bin-restore-button
  clickStopPropagation
  [iconOnly]="true"
  [isMatMenu]="false"
  [fileId]="file()?.id"
  [folderId]="folder()?.id"
  data-test="dms-grid-trash-bin-actions-template-button"
></iris-dms-trash-bin-restore-button>

@if (!!folder()) {
  <iris-dms-download-folder-button
    cssClass="grid-folder-action"
    clickStopPropagation
    [folderId]="folder()?.id"
    [iconOnly]="true"
    [isMatMenu]="false"
    data-test="dms-grid-trash-bin-actions-template-button-2"
  ></iris-dms-download-folder-button>
  <sk-button
    [appearance]="'icon'"
    clickStopPropagation
    [matTooltip]="'label.dms.ShowFolderInfo' | translate"
    (click)="openFolderInfo()"
    data-test="dms-grid-trash-bin-actions-template-show-folder-info-button">
    <em class="icon fa-fw fa fa-info-circle"></em>
  </sk-button>
} @else {
  <div class="flex-valign">
    <iris-dms-download-file-button clickStopPropagation [file]="file()" data-test="dms-grid-trash-bin-actions-template-button-3"></iris-dms-download-file-button>
    @if (isOfficeEditableDocument()) {
      <iris-dms-edit-office-file-button [file]="file()" data-test="dms-grid-trash-bin-actions-template-button-4"></iris-dms-edit-office-file-button>
    } @else {
      <iris-dms-file-preview-button [file]="file()" data-test="dms-grid-trash-bin-actions-template-button-5"></iris-dms-file-preview-button>
    }
    <sk-button
      [appearance]="'icon'"
      clickStopPropagation
      [matTooltip]="'label.dms.ShowFileInfo' | translate"
      (click)="openFileInfo()"
      data-test="dms-grid-trash-bin-actions-template-show-file-info-button">
      <em class="icon fa-fw fa fa-info-circle"></em>
    </sk-button>
  </div>
}
